import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../configs';

export const feenApi = createApi({
  reducerPath: 'feenApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config?.feenApiUrl,
  }),
  endpoints: (builder) => ({
    getHeaderData: builder.query({
      query: ({ club = 'mlb', lang }) => ({
        url: `/public/menuitems/_navs/header/${club}/global-nav${
          lang === 'es' ? '-es' : ''
        }`,
      }),
    }),
    getFooterData: builder.query({
      query: ({ club = 'mlb', lang }) => ({
        url: `/public/menuitems/_navs/footer/${club}/global-footer${
          lang === 'es' ? '-es' : ''
        }`,
      }),
    }),
    getSharedNav: builder.query({
      query: ({ lang }) => ({
        url: `/public/menuitems/_navs/_shared/shared-nav${
          lang === 'es' ? '-es' : ''
        }`,
      }),
      // This object needs to be updated by mlb-react-header but RTK query results are immutable
      // JSON.parse is used later to remove immutability
      transformResponse: (response) => JSON.stringify(response),
    }),
  }),
});

export const {
  useGetHeaderDataQuery,
  useGetFooterDataQuery,
  useGetSharedNavQuery,
} = feenApi;
